import React, { Component } from "react";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import DateTimePicker from "./DateTimePicker";
import Switcher from "../../ui/Switcher";

class PublishAtPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dateApi: null,
			publish: null,
			nowDate: new Date(moment().utc()),
			currentDate: null,
			interval: null,
		};
	}

	componentDidMount = () => {
		if (this.props.keepNowDateCurrent === true) {
			var interval = setInterval(this.setNowDate, 30000);
			this.setState({ interval });
		}
	};

	componentWillUnmount = () => {
		if (this.props.keepNowDateCurrent === true) {
			clearInterval(this.state.interval);
		}
	};

	setNowDate = () => {
		if (this.props.keepNowDateCurrent === true) {
			this.setState({
				nowDate: new Date(moment().utc()),
			});
			if (this.state.publish === "now") {
				this.state.dateApi.fieldApi.setValue(new Date(moment().utc()));
			}
		}
	};

	getDateApi = dateApi => {
		let { fieldApi } = dateApi;
		let currentDate = fieldApi.getValue();
		let publish = "never";
		if (currentDate) {
			//check if in past or future
			let diff = moment()
				.utc()
				.diff(moment(currentDate));
			if (diff > 0) {
				publish = "now";
			} else {
				publish = "later";
			}
		} else {
			currentDate = null;
		}
		this.setState({ dateApi, publish, currentDate });
	};

	isValidDate = current => {
		if (this.state.publish === "later") {
			var yesterday = moment().subtract(1, "day");
			return current.isAfter(yesterday);
		}
		return true;
	};

	changeType = (index, option) => {
		const { dateApi, nowDate, currentDate } = this.state;
		if (dateApi) {
			switch (option.value) {
				case "now":
					dateApi.fieldApi.setValue(nowDate);
					dateApi.fieldApi.setTouched(true);
					break;
				case "later":
					dateApi.fieldApi.setValue(currentDate);
					dateApi.fieldApi.setTouched(true);
					break;
				case "never":
					dateApi.removeDate();
					dateApi.fieldApi.setTouched(true);
					break;
				default:
					break;
			}
		}
		this.setState({ publish: option.value });
	};

	render() {
		let { field, placeholder, isRequired } = this.props;
		const { publish } = this.state;
		const switcherOptions = [
			{ label: "Now", value: "now" },
			{ label: "Later", value: "later" },
			{ label: "Never/Draft", value: "never" },
		];
		return (
			<div className={`switcher-container publish-at-picker ${publish === "later" ? "" : "hide-switcher-well"}`}>
				<div className="form-title ta-left p-left caption-text">
					{isRequired && <span className="isrequired-label">*</span>}
					{placeholder}
				</div>
				{this.state.publish && (
					<div>
						<Switcher
							initialValue={this.state.publish}
							options={switcherOptions}
							onSelect={this.changeType}
						/>
					</div>
				)}
				<div className="switcher-well">
					<DateTimePicker
						field={field}
						placeholder={""}
						getDateApi={this.getDateApi}
						isValidDate={this.isValidDate}
					/>
				</div>
			</div>
		);
	}
}
PublishAtPicker.propTypes = {
	field: PropTypes.string,
	onUpdate: PropTypes.func,
	value: PropTypes.any,
	timeZoneOffset: PropTypes.number,
	timezones: PropTypes.array,
	placeholder: PropTypes.string,
	timeZoneId: PropTypes.string,
	fieldState: PropTypes.object,
	user: PropTypes.object,
	isValidDate: PropTypes.func,
	isRequired: PropTypes.bool,
	keepNowDateCurrent: PropTypes.bool,
};

export default PublishAtPicker;
